import { buildPageLink } from 'Views/Page/Content/Templates';
import fr from 'facet-rest';
import { clientPaths } from 'Consts/Strings';
import React from 'react';
import useUserContext from 'Context/UserContext';
import useMessagesStatsContext from 'Context/MessagesStatsContext';
import { pathMatches } from 'Components/UI/Navigation/utils';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import PropTypes from 'prop-types';
import { Action } from './Action';

export const Messages = ({ onClick }) => {
  const { userResource, isAgent } = useUserContext();
  const { unreadThreadCount } = useMessagesStatsContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const onMessagesClick = () => {
    if (!isAgent) {
      logStandardizedEvent(categories.clientMessages,
        eventTypes.navigateTo,
        'Messages -  Navigated to Messages via new Bottom Nav');
    }
  };

  return userResource.withRelationship(
    fr.relationships.messagesPage.name,
    () => (
      <Action
        value="messages"
        icon="navMessages"
        label="Messages"
        onClick={() => {
          onClick();
          onMessagesClick();
        }}
        to={buildPageLink(userResource.relationship(fr.relationships.messagesPage.name).link('related'), clientPaths.messagesPage)}
        selectedIf={pathMatches(clientPaths.messagesPage, { isExact: false })}
        badge={unreadThreadCount === 0 ? undefined : {
          test: 'nav-messages-unread-badge',
          content: unreadThreadCount,
        }}
      />
    ),
    () => null,
  );
};

Messages.defaultProps = {
  onClick: undefined,
};
Messages.propTypes = {
  onClick: PropTypes.func,
};
